import { Component, input } from '@angular/core';
import { NavIcon } from './navegacion';

/**
 * Icono de una entrada del menú. Vive aparte porque lo dibujan tanto las
 * secciones (que en el menú expandido son la fila con icono) como las opciones
 * sueltas del rail: tener los trazos en un solo lugar evita repetir el juego
 * completo de SVG en cada sitio.
 *
 * Dos filas que se dibujan a la vez nunca comparten icono: en el rail colapsado
 * el icono es lo único que queda de la opción, así que dos iguales la vuelven
 * imposible de distinguir.
 */
@Component({
  selector: 'app-nav-icon',
  template: `
    @switch (icon()) {
      @case ('home') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M3 10.5 12 3l9 7.5" />
          <path d="M5 9.5V20a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9.5" />
          <path d="M9.5 21v-6h5v6" />
        </svg>
      }
      @case ('collection') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="3" y="3" width="7" height="7" rx="1.5" />
          <rect x="14" y="3" width="7" height="7" rx="1.5" />
          <rect x="3" y="14" width="7" height="7" rx="1.5" />
          <rect x="14" y="14" width="7" height="7" rx="1.5" />
        </svg>
      }
      @case ('copiar') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="8" y="8" width="13" height="13" rx="2" />
          <path d="M4 16a1 1 0 0 1-1-1V5a2 2 0 0 1 2-2h10a1 1 0 0 1 1 1" />
        </svg>
      }
      @case ('list') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M8 6h13M8 12h13M8 18h13" />
          <path d="M3 6h.01M3 12h.01M3 18h.01" />
        </svg>
      }
      @case ('clipboard') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="8" y="2" width="8" height="4" rx="1" />
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
          <path d="M9 12h6M9 16h6" />
        </svg>
      }
      <!-- Separación de muestras: la muestra repartida en tubos -->
      @case ('tubos') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M2.5 2.5H9" />
          <path d="M7.75 2.5v14a2.25 2.25 0 0 1-4.5 0v-14" />
          <path d="M3.25 11.5h4.5" />
          <path d="M15 2.5h6.5" />
          <path d="M20.25 2.5v14a2.25 2.25 0 0 1-4.5 0v-14" />
          <path d="M15.75 13.5h4.5" />
        </svg>
      }
      @case ('check') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="3" y="3" width="18" height="18" rx="3" />
          <path d="m8 12 2.5 2.5L16 9" />
        </svg>
      }
      @case ('dna') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M4 2c0 6 16 8 16 14M20 2C20 8 4 10 4 16M4 22c0-1.2.6-2.2 1.6-3.1M20 22c0-1.2-.6-2.2-1.6-3.1" />
          <path d="M7.5 5.5h9M6 9h12M6 15h12M7.5 18.5h9" />
        </svg>
      }
      @case ('drop') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M12 2.5 6.7 9.4a7 7 0 1 0 10.6 0Z" />
        </svg>
      }
      <!-- Brucelosis en leche: envase de leche -->
      @case ('leche') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M9 2h6v3.4l2.6 4a2 2 0 0 1 .4 1.1V20a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-9.5a2 2 0 0 1 .4-1.1L9 5.4V2Z" />
          <path d="M6.2 14h11.6" />
        </svg>
      }
      <!-- Hematología: células sanguíneas al microscopio -->
      @case ('celulas') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="9" cy="9" r="5" />
          <circle cx="9" cy="9" r="1.6" />
          <circle cx="17" cy="16.5" r="4" />
          <circle cx="17.5" cy="5.5" r="2.2" />
        </svg>
      }
      <!-- Virología: partícula viral con sus espículas -->
      @case ('virus') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="12" cy="12" r="6" />
          <circle cx="12" cy="12" r="1.8" />
          <path d="M12 6V2.5M12 17.5V21.5M6 12H2.5M17.5 12h4M7.8 7.8 5.3 5.3M16.2 7.8l2.5-2.5M7.8 16.2l-2.5 2.5M16.2 16.2l2.5 2.5" />
        </svg>
      }
      <!-- Anemia infecciosa equina: herradura -->
      @case ('caballo') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M8 21H6.5A1.5 1.5 0 0 1 5 19.5V11a7 7 0 0 1 14 0v8.5a1.5 1.5 0 0 1-1.5 1.5H16" />
          <path d="M9 21v-9.5a3 3 0 0 1 6 0V21" />
        </svg>
      }
      <!-- Diagnósticos aviares -->
      @case ('ave') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M16 7h.01" />
          <path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20" />
          <path d="m20 7 2 .5-2 .5" />
          <path d="M10 18v3M14 17.75V21" />
          <path d="M7 18a6 6 0 0 0 3.84-10.61" />
        </svg>
      }
      <!-- ELISA: microplaca de pocillos -->
      @case ('placa') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="2.5" y="5" width="19" height="14" rx="2" />
          <circle cx="7" cy="10" r="1.2" />
          <circle cx="12" cy="10" r="1.2" />
          <circle cx="17" cy="10" r="1.2" />
          <circle cx="7" cy="14.5" r="1.2" />
          <circle cx="12" cy="14.5" r="1.2" />
          <circle cx="17" cy="14.5" r="1.2" />
        </svg>
      }
      <!-- IDGA: placa de agar con el pocillo central y los periféricos -->
      @case ('petri') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="12" cy="12" r="9" />
          <circle cx="12" cy="12" r="1.8" />
          <circle cx="12" cy="6.8" r="1.1" />
          <circle cx="16.5" cy="9.4" r="1.1" />
          <circle cx="16.5" cy="14.6" r="1.1" />
          <circle cx="12" cy="17.2" r="1.1" />
          <circle cx="7.5" cy="14.6" r="1.1" />
          <circle cx="7.5" cy="9.4" r="1.1" />
        </svg>
      }
      <!-- Diagnósticos porcinos: hocico de cerdo -->
      @case ('cerdo') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M6.2 6.6 4.4 3.2l3.9 1.3M17.8 6.6l1.8-3.4-3.9 1.3" />
          <ellipse cx="12" cy="13" rx="8" ry="6.5" />
          <path d="M9.7 11.6v2.8M14.3 11.6v2.8" />
        </svg>
      }
      <!-- Bronquitis: aparato respiratorio -->
      @case ('pulmon') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M12 3v9" />
          <path d="M9 8.5C9 7 10.3 6 12 6s3 1 3 2.5" />
          <path d="M9 8.5c0 3-1.2 4.6-2.4 6.4A4.2 4.2 0 0 0 6 17.2v2.3a1.5 1.5 0 0 0 2 1.4l1.6-.6A2 2 0 0 0 11 18.4V12" />
          <path d="M15 8.5c0 3 1.2 4.6 2.4 6.4a4.2 4.2 0 0 1 .6 2.3v2.3a1.5 1.5 0 0 1-2 1.4l-1.6-.6a2 2 0 0 1-1.4-1.9V12" />
        </svg>
      }
      <!-- Titulación de vacuna: jeringa -->
      @case ('vacuna') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="m14.5 3.5 6 6" />
          <path d="m17.5 6.5-9.4 9.4a2 2 0 0 1-1 .5l-3 .6.6-3a2 2 0 0 1 .5-1l9.4-9.4" />
          <path d="m11 7 6 6" />
          <path d="M13 9.5 11.5 11M15.5 12 14 13.5" />
          <path d="m4.2 16.3-2.1 2.1M3 21l1.5-1.5" />
        </svg>
      }
      <!-- Diagnósticos bovinos: cabeza de res con cuernos -->
      @case ('bovino') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M4.5 5.5C2.8 6.6 2.4 8.8 3.6 10.3M19.5 5.5c1.7 1.1 2.1 3.3.9 4.8" />
          <path d="M4.5 5.5h3.2M19.5 5.5h-3.2" />
          <path d="M7.7 5.5v4.2a4.3 4.3 0 0 0 8.6 0V5.5" />
          <path d="M9.8 13.2h4.4a2.6 2.6 0 0 1 0 5.2H9.8a2.6 2.6 0 0 1 0-5.2Z" />
          <path d="M11 15.6h.01M13 15.6h.01" />
        </svg>
      }
      <!-- Perfil serológico: curva de títulos -->
      @case ('grafico') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M3 3v16a2 2 0 0 0 2 2h16" />
          <path d="m7 15 3.5-4.5 3 2.5L20 6" />
        </svg>
      }
      <!-- PCR en tiempo real: termociclador -->
      @case ('termociclador') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M7 7V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2" />
          <rect x="3" y="7" width="18" height="13" rx="2" />
          <path d="M6.5 12h5M6.5 16h8" />
          <circle cx="17" cy="12.5" r="1.5" />
        </svg>
      }
      <!-- Biología molecular: molécula -->
      @case ('molecula') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="5" cy="6" r="2.5" />
          <circle cx="19" cy="8" r="2.5" />
          <circle cx="12" cy="18" r="2.5" />
          <path d="m7.4 6.3 9.2 1.3M6.3 8.1l4.4 7.7M17.6 10.1l-4.2 5.9" />
        </svg>
      }
      @case ('report') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8Z" />
          <path d="M14 2v6h6" />
          <path d="m9 14 2 2 4-4" />
        </svg>
      }
      @case ('receipt') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M5 2v20l2.5-1.5L10 22l2-1.5L14 22l2.5-1.5L19 22V2l-2.5 1.5L14 2l-2 1.5L10 2 7.5 3.5Z" />
          <path d="M9 8h6M9 12h6M9 16h3" />
        </svg>
      }
      <!-- Servicios: etiqueta de precio -->
      @case ('etiqueta') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M20.6 12.6 12.4 20.8a2 2 0 0 1-2.8 0l-6.4-6.4a2 2 0 0 1-.6-1.4V4.8a2 2 0 0 1 2-2h8.2a2 2 0 0 1 1.4.6l6.4 6.4a2 2 0 0 1 0 2.8Z" />
          <path d="M7.5 7.5h.01" />
        </svg>
      }
      <!-- Bacteriología: bacilo con sus flagelos -->
      @case ('bacteria') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="6" y="8.5" width="12" height="7" rx="3.5" transform="rotate(-20 12 12)" />
          <path d="M4.4 15.6c-1 .5-1.6 1.3-1.8 2.3M6.6 17.9c-.4.9-.3 1.8.1 2.6" />
          <path d="M19.6 8.4c1-.5 1.6-1.3 1.8-2.3M17.4 6.1c.4-.9.3-1.8-.1-2.6" />
        </svg>
      }
      <!-- Monitoreo de ambiente: placa expuesta al aire -->
      @case ('ambiente') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M3.5 17.5h17" />
          <path d="M5 17.5a7 7 0 0 1 14 0" />
          <circle cx="10" cy="14" r="1" />
          <circle cx="14.5" cy="13" r="1" />
          <path d="M4 5.5h6a2 2 0 1 0-2-2M13 8.5h6a2 2 0 1 1-2 2" />
        </svg>
      }
      <!-- Bacteriológico de agua: gota sobre el nivel del agua -->
      @case ('agua') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M12 2.5c2.6 3.1 4.2 5.4 4.2 7.4a4.2 4.2 0 0 1-8.4 0c0-2 1.6-4.3 4.2-7.4Z" />
          <path d="M2.5 17c1.6 0 1.6 1.4 3.2 1.4S7.3 17 8.9 17s1.6 1.4 3.2 1.4S13.7 17 15.3 17s1.6 1.4 3.2 1.4S20.1 17 21.5 17" />
        </svg>
      }
      <!-- Aislamiento y antibiograma: asa de siembra sobre el cultivo -->
      @case ('cultivo') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M3.5 14.5a7.5 7.5 0 0 0 15 0Z" />
          <path d="M2.5 14.5h17" />
          <path d="M15 11.5V6.2a2.7 2.7 0 1 1 5.4 0" />
          <circle cx="9" cy="17.5" r="1" />
          <circle cx="13" cy="17" r="1" />
        </svg>
      }
      <!-- Cultivo aviar: huevo embrionado -->
      @case ('huevo') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M12 2.5c3.6 0 6.5 5.4 6.5 9.8a6.5 6.5 0 0 1-13 0c0-4.4 2.9-9.8 6.5-9.8Z" />
          <circle cx="12" cy="12.8" r="2.6" />
        </svg>
      }
      <!-- Aislamiento de bacterias y hongos: seta -->
      @case ('hongo') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M3.5 11.5a8.5 8.5 0 0 1 17 0Z" />
          <path d="M10 11.5v7a2 2 0 0 0 4 0v-7" />
        </svg>
      }
      <!-- Aislamiento de M. bovis: microscopio -->
      @case ('microscopio') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M6 21h15" />
          <path d="M9 21a6 6 0 0 0 5-9.3" />
          <path d="M11.5 3 8 5l3.5 6 3.5-2Z" />
          <path d="M8.5 12.5 7 13.5" />
          <path d="M5.5 17h5" />
        </svg>
      }
      <!-- Determinación cuantitativa: contador de colonias por cuadrantes -->
      @case ('recuento') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 3v18M3 12h18" />
          <circle cx="8" cy="8" r="1" />
          <circle cx="16.2" cy="8" r="1" />
          <circle cx="8" cy="16.2" r="1" />
        </svg>
      }
      <!-- Cultivo por Salmonella: bacilo con flagelos -->
      @case ('salmonella') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="7" y="9.5" width="10" height="5" rx="2.5" transform="rotate(-20 12 12)" />
          <path d="M5.5 15.5c-1.2.6-2 1.3-2.5 2.2" />
          <path d="M6.8 17.4c-.9.9-1.4 1.7-1.6 2.6" />
          <path d="M18.5 8.5c1.2-.6 2-1.3 2.5-2.2" />
        </svg>
      }
      <!-- Leptospira: espiroqueta, la forma en gancho del género -->
      @case ('espiroqueta') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M3 15c1.5-2 3-2 4.5 0s3 2 4.5 0 3-2 4.5 0" />
          <path d="M4.5 9.5C6 7.5 7.5 7.5 9 9.5s3 2 4.5 0" />
          <path d="M18 12.5c1.6-.6 2.6-2 2.4-3.4-.2-1.3-1.3-2.1-2.4-1.8" />
        </svg>
      }
      <!-- Microaglutinación: pocillos de la placa, con el grumo del positivo -->
      @case ('microaglutinacion') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="3" y="5" width="18" height="14" rx="2" />
          <circle cx="8" cy="10" r="1.6" />
          <circle cx="13.5" cy="10" r="1.6" />
          <circle cx="8" cy="15" r="1.6" />
          <path d="M18 13.5v.01M18 9.5v.01" />
        </svg>
      }
      <!-- Aislamiento de Leptospira: tubo de cultivo con el medio inoculado -->
      @case ('cultivo-lepto') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M9 3h6" />
          <path d="M10 3v14a2.5 2.5 0 0 0 5 0V3" />
          <path d="M10 12.5c1.2-1 2.8-1 4 0" />
          <path d="M12.5 8.5v.01" />
        </svg>
      }
      <!-- Rabia: cabeza de cánido, el reservorio del virus -->
      @case ('rabia') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M4 4.5 7 8" />
          <path d="M20 4.5 17 8" />
          <path d="M4 4.5V10a8 8 0 0 0 4 6.9V19a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2.1A8 8 0 0 0 20 10V4.5" />
          <path d="M10 11v.01M14 11v.01" />
        </svg>
      }
      <!-- IFD: microscopio de fluorescencia (el haz sobre la platina) -->
      @case ('microscopio-fluor') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M6 20h12" />
          <path d="M9 20v-3a4 4 0 0 1 4-4h1" />
          <path d="M12 3h3v6h-3z" />
          <path d="M5 10l2.5 2.5M4.5 14h3M6 6.5 8 8" />
        </svg>
      }
      <!-- Prueba biológica: el ratón de la inoculación -->
      @case ('raton') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="7.5" cy="9" r="2.5" />
          <path d="M9.5 10.5A6 6 0 0 1 15 17h-1a5 5 0 0 1-5-5" />
          <path d="M15 17c2.5 0 4-1 4-2.5" />
          <path d="M6 13.5c-1.6.8-2.5 2-2.5 3.5" />
        </svg>
      }
      <!-- EEB: el cerebro, que es donde se busca la lesión espongiforme -->
      @case ('cerebro') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M12 5.5a3 3 0 0 0-5.7-1.3A2.8 2.8 0 0 0 4 7a2.9 2.9 0 0 0 .6 1.8A3 3 0 0 0 5 14.4V16a3 3 0 0 0 4.5 2.6" />
          <path d="M12 5.5a3 3 0 0 1 5.7-1.3A2.8 2.8 0 0 1 20 7a2.9 2.9 0 0 1-.6 1.8A3 3 0 0 1 19 14.4V16a3 3 0 0 1-4.5 2.6" />
          <path d="M12 5.5V20" />
        </svg>
      }
      <!-- Ixodicida: la garrapata sobre la que se evalúa el plaguicida -->
      @case ('garrapata') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <ellipse cx="12" cy="13" rx="5" ry="6" />
          <circle cx="12" cy="5.5" r="2" />
          <path d="M7 9 3.5 6.5M7 13H3M7 17l-3.5 2.5" />
          <path d="m17 9 3.5-2.5M17 13h4M17 17l3.5 2.5" />
        </svg>
      }
      <!-- Espermograma: el espermatozoide, lo que se lee al microscopio -->
      @case ('espermatozoide') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="6.5" cy="6.5" r="3" />
          <path d="M9 8.5c3 2.5 1 5 3 6.5s4-1 5.5.5" />
          <path d="M20 17c-.5 1.5-2 2.5-3.5 2" />
        </svg>
      }
      <!-- Nosema: la abeja, sobre la que se investiga la infección -->
      @case ('abeja') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <ellipse cx="12" cy="14" rx="4" ry="6" />
          <path d="M8 12h8M8 16h8" />
          <circle cx="12" cy="5.5" r="2.5" />
          <path d="M10.5 3.5 8 2M13.5 3.5 16 2" />
          <path d="M8.5 9.5C6.5 7.5 3 8 3 10.5M15.5 9.5c2-2 5.5-1.5 5.5 1" />
        </svg>
      }
      <!-- GBG: la larva del díptero, que es lo que se identifica -->
      @case ('larva') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M5 15c0-4 3-7 7-7s7 2.5 7 6-3 5-6 5H8a3 3 0 0 1-3-3Z" />
          <path d="M8.5 9.5 9 14M12 8.2 12.5 14M15.5 9.2 15.5 14" />
          <path d="M11 6.5 10 4.5M13 6.5 14.5 4.8" />
        </svg>
      }
      <!-- Aethina tumida: el escarabajo que se identifica -->
      @case ('escarabajo') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <ellipse cx="12" cy="13.5" rx="5" ry="6.5" />
          <path d="M12 7v13" />
          <circle cx="12" cy="5" r="2" />
          <path d="M10.5 3.5 9 2M13.5 3.5 15 2" />
          <path d="M7 10 3.5 8M7 14H3.5M7 17.5 4 19.5" />
          <path d="m17 10 3.5-2M17 14h3.5M17 17.5 20 19.5" />
        </svg>
      }
      <!-- Endoparásitos: el helminto que se busca en las heces -->
      @case ('lombriz') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <path d="M5 18c0-3 3-3 3-6s-3-3-3-6" />
          <path d="M11 18c0-3 3-3 3-6s-3-3-3-6" />
          <path d="M17 18c0-3 3-3 3-6s-3-3-3-6" />
        </svg>
      }
      <!-- Plantillas de documento: maqueta de la hoja -->
      @case ('plantilla') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <rect x="3" y="3" width="18" height="18" rx="2" />
          <path d="M3 9h18M9.5 21V9" />
        </svg>
      }
      <!-- Usuarios: dos personas (distinto del 'paciente', que es una sola) -->
      @case ('usuarios') {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4.5 shrink-0">
          <circle cx="9" cy="7" r="3.5" />
          <path d="M2 21v-1a6 6 0 0 1 6-6h2a6 6 0 0 1 6 6v1" />
          <path d="M16 3.6a3.5 3.5 0 0 1 0 6.8" />
          <path d="M19 14.2A6 6 0 0 1 22 19.5V21" />
        </svg>
      }
    }
  `,
  host: { class: 'contents' },
})
export class NavIconComponent {
  readonly icon = input.required<NavIcon>();
}
